import React from 'react'
import './ButtonCe.scss'

interface btnProps {
    styleCustomize: string,
    txtButton: string,
    onClick?: (event:any) => void,
    disabledButton: boolean,
}

const ButtonCe = ({
    styleCustomize,
    txtButton,
    onClick,
    disabledButton,
}: btnProps) => {
  return (
    <div className='ce-als-button'>
        <button className={styleCustomize} disabled={disabledButton} onClick={onClick}>
            {txtButton}
        </button>
    </div>
  )
}

export default ButtonCe